/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rte_No_ResultsInputs */



/**
* | output |
* | --- |
* | "No options found" |
*
* @param {Rte_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const rte_no_results = /** @type {((inputs?: Rte_No_ResultsInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rte_No_ResultsInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Geen opties gevonden")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune option trouvée")
	return /** @type {LocalizedString} */ ("No options found")
});